import { COLORS } from "../../components/charts/config";
import moment from "moment";
import _ from "lodash";

export function getListCountry(rawData) {
  let countries = [];
  if (!rawData || typeof rawData !== "object") {
    return;
  }
  const tmpCountries = Object.keys(rawData).sort((a, b) => a - b);

  countries.push("All");
  tmpCountries.forEach(country => countries.push(country));

  countries = countries.sort((a, b) => a - b);
  return countries;
}

export function getListSites(rawData, block = []) {
  if (!rawData || typeof rawData !== "object") {
    return;
  }

  const mapSiteCountry = {};
  let tmpSites = [];
  Object.entries(rawData).map(element => {
    Object.entries(element[1]).map(elem => {
      if (!block.includes(elem[0])) {
        tmpSites.push(elem[0]);
        mapSiteCountry[elem[0]] = element[0];
      }
    });
  });
  tmpSites = tmpSites.sort((a, b) => a - b);
  return {
    allSites: tmpSites,
    mapSiteCountry
  };
}

export function sum(numInArrayOld = []) {
  let numInArray = numInArrayOld;
  if (!numInArray || !Array.isArray(numInArray)) {
    numInArray = [0];
  }

  return numInArray.length === 0 ? 0 : numInArray[0] + sum(numInArray.slice(1));
}

export function getRandomColor() {
  const baseColorLength = COLORS.length;
  const min = 0;
  const max = baseColorLength;
  const colorIndex = Math.random() * (max - min);
  const index = Math.floor(colorIndex + min);

  return COLORS[index];
}

// DEPRECATED!!! Please use func getThreadID
export function setParticipantName(listParticipant, participantId) {
  let name = "";
  const dataSources = _.cloneDeep(listParticipant);
  const isEmptyParticipant = _.isEmpty(listParticipant) && !Array.isArray(listParticipant);

  name = dataSources.filter(ds => ds.participantId === participantId);
  const isEmptyName = _.isEmpty(name) || _.isEmpty(name[0].participantName);

  if (isEmptyParticipant) {
    return;
  }

  if (isEmptyName) {
    return participantId;
  }

  return name[0].participantName;
}

function getCountriesByActivities(rawData) {
  const isEmptyRaw = _.isEmpty(rawData);

  if (!isEmptyRaw) {
    let countriesList = new Set();
    for (const activityName in rawData) {
      const activities = rawData[activityName];
      for (const countryName in activities) {
        countriesList.add(countryName);
      }
    }

    return (countriesList = [...countriesList].sort((a, b) => b - a));
  }

  return [];
}

function getSiteByActivities(rawData, choosenCountries = []) {
  const isEmptyRaw = _.isEmpty(rawData);

  if (!isEmptyRaw) {
    let siteList = new Set();
    for (const activityName in rawData) {
      const activities = rawData[activityName];
      choosenCountries.forEach(countryName => {
        if (countryName in activities) {
          const sites = activities[countryName];

          for (const sitename in sites) {
            siteList.add(sitename);
          }
        }
      });
    }

    return (siteList = [...siteList].sort((a, b) => b - a));
  }

  return [];
}

function getCountries(data) {
  if (_.isEmpty(data)) {
    return [];
  }
  const countries = Object.keys(data);

  return _.orderBy(Array.from(countries), [countryName => countryName.toLowerCase()]);
}

function getSites(data, choosedCountries = []) {
  const isEmptyData = _.isEmpty(data) || choosedCountries.length < 1;

  let siteList = new Set();
  if (!isEmptyData) {
    choosedCountries.forEach(countryName => {
      const countries = data[countryName];
      for (const siteName in countries) {
        siteList.add(siteName);
      }
    });

    siteList = [...siteList];
    return _.orderBy(Array.from(siteList), [siteName => siteName.toLowerCase()]);
  }

  return [];
}

function getCountriesFromD3NestResult(dataSources = []) {
  const isValidData = Array.isArray(dataSources) && dataSources.length > 0;
  let result = [];
  if (isValidData) {
    // Looping first data in group date
    for (let i = 0; i < dataSources.length; i++) {
      const countries = dataSources[i].values || [];
      result.push(...countries.map(c => c.key));
    }
  }

  result = [...result];
  return _.orderBy(Array.from(result), [country => country.toLowerCase()]);
}

function getSitesFromD3NestResult(dataSources = [], choosenCountries = []) {
  const isValidData = Array.isArray(dataSources) && dataSources.length > 0;
  const choosenCountriesNotNull = Array.isArray(choosenCountries) && choosenCountries.length > 0;

  let result = new Set();
  if (isValidData) {
    if (choosenCountriesNotNull) {
      choosenCountries.forEach(countryName => {
        // Looping first data in group date
        for (let i = 0; i < dataSources.length; i++) {
          const countries = dataSources[i].values || [];
          const countryData = countries.filter(c => c.key === countryName);

          for (let j = 0; j < countryData.length; j++) {
            const siteData = countryData[j].values || [];
            result.add(...siteData.map(site => site.key));
          }
        }
      });
    }
  }

  result = [...result];
  return _.orderBy(Array.from(result), [site => site.toLowerCase()]);
}

function getAllSitesWhenFilteringCountry(payload, choosenCountries = []) {
  let result = [];
  const { countries, countriesByActivities, countriesByD3Nest } = payload;
  const isNotEmptyCountries = Array.isArray(choosenCountries) && choosenCountries.length > 0;

  if (!isNotEmptyCountries) {
    return result;
  }

  choosenCountries.forEach(countryName => {
    // Get all sites by countries
    if (countries) {
      const countriesKeys = Object.keys(countries);
      if (countriesKeys.indexOf(countryName) > -1) {
        if (countries[countryName]) {
          const siteName = Object.keys(countries[countryName]);
          result.push(...siteName);
        }
      }
    }

    // Get all sites by activities
    if (countriesByActivities) {
      for (const activityName in countriesByActivities) {
        const activities = countriesByActivities[activityName];
        if (activities) {
          const countriesData = activities[countryName];
          const countriesKey = Object.keys(activities);

          if (countriesData && countriesKey.indexOf(countryName) > -1) {
            result.push(...Object.keys(countriesData));
          }
        }
      }
    }

    // Get all sites by d3 nest response
    if (countriesByD3Nest) {
      for (let i = 0; i < countriesByD3Nest.length; i++) {
        const countries = countriesByD3Nest[i].values || [];
        const countryData = countries.filter(c => c.key === countryName);

        for (let j = 0; j < countryData.length; j++) {
          const siteData = countryData[j].values || [];
          result.push(...siteData.map(site => site.key));
        }
      }
    }
  });

  result = _.uniq(result);
  result = _.orderBy(Array.from(result), [sitename => sitename.toLowerCase()]);
  return result;
}

function convertArrToString(arrObj) {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
}

function getThreadID(siteListInParticipants = [], id = "") {
  let payload = {
    threadID: "",
    participantId: "",
    isThreadID: false
  };
  if (!Array.isArray(siteListInParticipants) && !id) {
    payload.threadID = id;
  }

  payload = siteListInParticipants
    .filter(ftd => ftd.participantId === id)
    .map(mftd => {
      if (mftd.participantName) {
        return {
          threadID: mftd.participantId,
          participantId: mftd.participantName,
          isThreadID: true
        };
      } else {
        return {
          threadID: mftd.participantId,
          participantId: "",
          isThreadID: false
        };
      }
    })[0];

  return payload;
}

function getPrimaryColorFunc() {
  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#00C3B3";
  return primaryColor;
}

function getContrastTextColor(hexcolorOld) {
  let hexcolor = hexcolorOld;
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }

  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split("")
      .map(function(hex) {
        return hex + hex;
      })
      .join("");
  }

  const r = parseInt(hexcolor.substr(0, 2), 16) * 299;
  const g = parseInt(hexcolor.substr(2, 2), 16) * 587;
  const b = parseInt(hexcolor.substr(4, 2), 16) * 114;

  const yiq = (r + g + b) / 1000;
  return yiq >= 128 ? "black" : "white";
}

function generateParticipantId(participants) {
  if (participants && participants.isThreadID) {
    return participants.participantId;
  }

  return participants && participants.threadID;
}

function getShadeColor(color, percent) {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
  const GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
  const BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
}

function mappingSiteCountry(rawData, mode = "general") {
  const result = {};
  if (!rawData) {
    return result;
  }

  switch (mode) {
    case "general": {
      for (const countryName in rawData) {
        const countryData = rawData[countryName];

        for (const siteName in countryData) {
          if (!(siteName in result)) {
            result[siteName] = countryName;
          }
        }
      }
      break;
    }
    case "activities": {
      for (const activityName in rawData) {
        const activityData = rawData[activityName];

        for (const countryName in activityData) {
          const countryData = activityData[countryName];

          for (const siteName in countryData) {
            if (!(siteName in result)) {
              result[siteName] = countryName;
            }
          }
        }
      }
      break;
    }
    case "d3": {
      for (let i = 0; i < rawData.length; i++) {
        const countriesData = rawData[i].values || [];

        for (let j = 0; j < countriesData.length; j++) {
          const siteData = countriesData[j].values || [];

          siteData.map(sd => {
            if (!(sd.key in result)) {
              result[sd.key] = countriesData[j].key;
            }
          });
        }
      }
      break;
    }
    default:
      break;
  }

  return result;
}

function createRandom(min, max) {
  return Math.floor(Math.random() * (max - min)) + 1;
}

function getSitesCountriesFromSitesApi(rawData, participantSiteIds, specificSiteId = []) {
  const response = {
    countryNames: [],
    countryIdNameMaps: [],
    siteNames: [],
    siteIdNameMaps: [],
    countrySiteMaps: []
  };

  if (_.isEmpty(rawData) || _.isEmpty(participantSiteIds)) {
    return response;
  }

  rawData.forEach(data => {
    if (participantSiteIds.includes(data.id)) {
      response.siteNames = _.union(response.siteNames, [data.name]);
      const siteIdNameMap = { id: data.id, name: data.name };
      response.siteIdNameMaps.push(siteIdNameMap);
      data.countryList.forEach(countryData => {
        response.countryNames = _.union(response.countryNames, [countryData.countryName]);
        const countryIdNameMap = {
          id: countryData.countryId,
          name: countryData.countryName
        };
        response.countryIdNameMaps.push(countryIdNameMap);
      });
    }
  });

  response.countryNames.forEach(countryName => {
    const sites = [];
    rawData.forEach(data => {
      data.countryNameList.forEach(country => {
        if (country == countryName) {
          if (specificSiteId && specificSiteId.length > 0) {
            if (specificSiteId[0] == data.id) {
              sites.push(data.name);
            }
          } else {
            sites.push(data.name);
          }
        }
      });
    });
    response.countrySiteMaps.push({ country: countryName, sites: sites });
  });

  return response;
}

function getSiteNameAndCountryNameMaps(rawData) {
  const response = {
    countryNames: [],
    countryIdNameMaps: [],
    siteNames: [],
    siteIdNameMaps: []
  };

  if (_.isEmpty(rawData)) {
    return response;
  }

  rawData.forEach(data => {
    response.siteNames = _.union(response.siteNames, [data.name]);
    const siteIdNameMap = { id: data.id, name: data.name };
    const siteIdNameMapIndex = response.siteIdNameMaps.findIndex(siteIdNameMap => siteIdNameMap.id == data.id);
    if (siteIdNameMapIndex == -1) {
      response.siteIdNameMaps.push(siteIdNameMap);
    }
    data.countryList.forEach(countryData => {
      response.countryNames = _.union(response.countryNames, [countryData.countryName]);
      const countryIdNameMap = {
        id: countryData.countryId,
        name: countryData.countryName
      };
      const countryIdNameMapIndex = response.countryIdNameMaps.findIndex(countryIdNameMap => countryIdNameMap.id == countryData.countryId);
      if (countryIdNameMapIndex == -1) {
        response.countryIdNameMaps.push(countryIdNameMap);
      }
    });
  });

  return response;
}

function getSitesWhenFilteringCountry(countriesSitesMap, countriesSelected = []) {
  const sites = [];

  countriesSitesMap.forEach(data => {
    if (countriesSelected.includes(data.country)) {
      data.sites.forEach(site => {
        sites.push(site);
      });
    }
  });

  return sites;
}

function getSiteIdsBySiteNames(siteIdNameMaps, sitesSelected = []) {
  const siteIds = [];

  if (sitesSelected.length == 0 || sitesSelected[0] == "all") {
    return siteIds;
  }

  siteIdNameMaps.forEach(data => {
    if (sitesSelected.includes(data.name)) {
      siteIds.push(data.id);
    }
  });

  return siteIds;
}

function getSiteIdsFromParticipantApi(rawData, selectedParticipants = []) {
  let siteIds = [];

  if (_.isEmpty(rawData)) {
    return siteIds;
  }

  let newRawData = rawData;

  if (selectedParticipants.length > 0 && selectedParticipants[0] != "all") {
    newRawData = [];
    rawData.forEach(data => {
      if (selectedParticipants.includes(data.id)) {
        newRawData.push(data);
      }
    });
  }

  newRawData.forEach(data => {
    siteIds = _.union(siteIds, [data.siteId]);
  });

  return siteIds;
}
function getStatusListJSON(responseArr) {
  const ar = responseArr;
  const object = {};
  ar.map(a => {
    object[a] = a;
  });
  return object;
}

function getReasonListJSON(responseArr, statusItem) {
  const ar = responseArr;
  const object = [];
  let reason = [];
  ar.forEach(function(a) {
    const stat = a.status;
    if (statusItem == "DISCONTINUED") {
      reason = a.reasonList.sort();
    } else {
      reason = a.reasonList.sort().reverse();
    }
    if (statusItem === stat && reason) {
      reason.map(r => {
        const obj = {
          text: r,
          value: r
        };
        object.push(obj);
      });
    }
  });
  return object;
}

function getCountryIds(countryNames, sitesDetails = []) {
  let countryIds = [];
  countryNames.map(countryName => {
    sitesDetails.forEach(site => {
      if (site.countryList[0].countryName === countryName) {
        countryIds.push(site.countryList[0].countryId);
      }
    });
  });
  countryIds = [...new Set(countryIds)];
  return countryIds;
}

function getSiteIds(siteNames, sitesDetails = []) {
  const siteIds = [];
  siteNames.map(siteName => {
    sitesDetails.forEach(site => {
      if (site.name === siteName) {
        siteIds.push(site.id);
      }
    });
  });
  return siteIds;
}

function getColorPalette(container) {
  if (container == "light") {
    return "#7F69D5, #D6B2CE, #A6CEE3, #6994D4, #FB9A99, #B9DFD1, #B269D5, #FDBF6F, #7893F3, #83C6A8";
  } else if (container == "gradient" || container == "dark") {
    return "#A692F3, #D6B2CE, #A6CEE3, #6994D4, #FB9A99, #B9DFD1, #D08FEF, #FDBF6F, #8FA4EF, #6EDBAA";
  }
}

function convertMonthToTimestamps(month) {
  if (!month || typeof month !== "string") {
    return;
  }
  return new Date(moment.utc(month)).getTime();
}

function convertMonthToTimestampsByMonth(month) {
  if (!month || typeof month !== "string") {
    return;
  }
  // In this chart only month is getting compared not the dates,
  // so we need to convert the month to timestamp so added default 1 as date
  return new Date(moment.utc(month, "MMM YYYY")).setDate(1);
}

function getCountryWhenSiteFilterApply(filter, choosenCountry, siteDetail, countryNameList) {
  const country = [];

  if (_.isEmpty(filter)) {
    return country;
  }

  if (filter === ["all"] || filter === "all") {
    return "all";
  }

  filter.forEach(siteName => {
    siteDetail.forEach(sitesDetails => {
      if (sitesDetails.name === siteName) {
        sitesDetails.countryNameList.forEach(countries => {
          if (!country.includes(countries) && countryNameList.includes(countries)) {
            country.push(countries);
          }
        });
      }
    });
  });
  return country;
}

export {
  getCountriesByActivities,
  getSiteByActivities,
  getCountries,
  getSites,
  getCountriesFromD3NestResult,
  getSitesFromD3NestResult,
  getAllSitesWhenFilteringCountry,
  convertArrToString,
  getThreadID,
  getPrimaryColorFunc,
  getContrastTextColor,
  generateParticipantId,
  getShadeColor,
  mappingSiteCountry,
  createRandom,
  getSitesCountriesFromSitesApi,
  getSitesWhenFilteringCountry,
  getSiteIdsBySiteNames,
  getSiteIdsFromParticipantApi,
  getColorPalette,
  convertMonthToTimestamps,
  convertMonthToTimestampsByMonth,
  getCountryIds,
  getSiteIds,
  getStatusListJSON,
  getReasonListJSON,
  getSiteNameAndCountryNameMaps,
  getCountryWhenSiteFilterApply
};
